import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, appendSiteName = true }) => {
  const siteName = "Fileincanada";
  const fullTitle = title ? (appendSiteName ? `${title} | ${siteName}` : title) : siteName;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
    </Helmet>
  );
};

export default SEO;
